import Vue from 'vue';
export default ({ app, context }, inject) => {
	const page = {
		login: '/login',
		error: '/error',
		about: '/about.pdf',

		user: {
			dashboard: '/user/',
			notification: '',
			connections: '',
			appConfig: '/user/appconfig',
			onetimePass: '/user/onetimepass',
			userConfig: '/user/userconfig',
			policy: '/privacy_policy.pdf',
			term: () => {
				return app.$tenantType.getUserTermLink();
			},

			question: '/user/question',
			manual: () => {
				return app.$tenantType.getUserManualLink();
			},
			manual_mac: () => {
				return app.$tenantType.getUserManualLinkMac();
			},
			manual_android: () => {
				return app.$tenantType.getUserManualLinkAndroid();
			},
			qAndA: (id = '') => {
				return '/user/qanda/' + id;
			},
		},

		tenantAdmin: {
			dashboard: '/tenantadmin/',

			userList: {
				index: '/tenantadmin/userlist',
				detail: (id) => {
					return `/tenantadmin/userlist/${id}`;
				},
				detailConnection: (id) => {
					return `/tenantadmin/userlist/${id}?tab=connection`;
				},
				register: '/tenantadmin/userlist/register',
			},
			ownerConfig: '/tenantadmin/ownerconfig',
			announcement: {
				index: '/tenantadmin/annoucement',
			},

			settings: '/tenantadmin/settings',
			statistics: '/tenantadmin/stats',
			log: '/tenantadmin/logview',
			questionList: {
				index: '/tenantadmin/questionlist',
				detail: (id) => {
					return `/tenantadmin/questionlist/${id}`;
				},
				register: '/tenantadmin/questionlist/register',
			},

			manual: () => {
				return app.$tenantType.getTenadManualLink();
			},
			policy: '/privacy_policy.pdf',
			term: () => {
				return app.$tenantType.getTenadTermLink();
			},
			qAndA: (id = '') => {
				return '/tenantadmin/qanda/' + id;
			},

			informations: {
				index: '/tenantadmin/informations',
				detail: (id) => {
					return `/tenantadmin/informations/${id}`;
				},
				register: '/tenantadmin/informations/register',
			},
		},

		systemAdmin: {
			dashboard: '/systemadmin/',
			statistics: '',
			tenantList: '',
			log: '',
			question: '',
			config: '',
			notification: '',

			manual: '',
		},
	};
	inject('page', page);
};
